import React from 'react';
import Flowchart from './Flowchart';

export default function CurriculumFlowchart({ subjects = [], department = '', yearLabel = '' }) {
  return (
    <div style={{ marginTop: 24, padding: 20, border: '1px solid #ddd', borderRadius: 12, background: '#fff' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16 }}>
        <div>
          <h3 style={{ margin: 0, fontSize: 20, color: '#155c2b' }}>Curriculum Flowchart</h3>
          <div style={{ color: '#555', fontSize: 14 }}>Showing {department || 'department'} curriculum for {yearLabel || 'All Years'}.</div>
        </div>
      </div>
      <Flowchart subjects={subjects} department={department} yearLabel={yearLabel} />
    </div>
  );
}
